(function ($) {
  const { map, max } = lodash;
  const activeClassName = "active";
  const defaultBreakpoint = 576;
  const defaultExpanded = false;

  const toggleActiveTab = (btn) => {
    btn.parent().siblings(".card").removeClass(activeClassName);
    btn.parent().toggleClass(activeClassName);
  };

  $(".bs-advance-accordion").each((index, accordion) => {
    const $accordion = $(accordion);
    $accordion.find(".accordion__block__btn").on("click", (e) => {
      $button = $(e.target);
      toggleActiveTab($button);
      const target = $button.data("target");
      const $leftContentPanel = $(
        `.bs-advance-accordion__left-content-panel[data-parent='${target}']`
      );
      if (target && $leftContentPanel) {
        $accordion
          .find(`.bs-advance-accordion__left-content-panel`)
          .removeClass("show");
        $leftContentPanel.addClass("show");
      }
    });
  });

  const applyColumnStyle = () => {
    $(".bs-advance-accordion").each((i, accordion) => {
      const $accordion = $(accordion);
      const breakpointWidth =
        $accordion.data("attributes")?.colBreakpoint || defaultBreakpoint;
      const alwaysExpanded =
        $accordion.data("attributes")?.alwaysExpanded || defaultExpanded;

      if ($(window).width() < breakpointWidth) {
        $accordion
          .addClass("bs-advance-accordion--single-col")
          .find(
            ".bs-advance-accordion__left-container .bs-advance-accordion__left-content-panel "
          )
          .each((i, panel) => {
            const $panel = $(panel);
            $($panel.data("parent")).append(panel);
          });
        if (alwaysExpanded) {
          $accordion
            .find(".bs-advance-accordion__right-container .card > div")
            .removeClass("expand-fixed");
        }
      } else {
        $accordion
          .removeClass("bs-advance-accordion--single-col")
          .find(
            ".bs-advance-accordion__right-container .bs-advance-accordion__left-content-panel"
          )
          .each((i, panel) => {
            $accordion
              .find(".bs-advance-accordion__left-container")
              .append(panel);
          });
        if (alwaysExpanded) {
          $accordion
            .find(".bs-advance-accordion__right-container .card > div")
            .addClass("expand-fixed");
        }
      }
    });
  };

  const setPanelHeights = () => {
    $(".bs-advance-accordion").each((index, accordion) => {
      const $accordion = $(accordion);

      const breakpointWidth =
        $accordion.data("attributes")?.colBreakpoint || defaultBreakpoint;

      const $cardCollection = $accordion.find(
        ".bs-advance-accordion__right-container .card .collapse"
      );
      const $accLeftContainer = $accordion.find(
        ".bs-advance-accordion__left-container"
      );

      $cardCollection.find(".card-body").height("");
      $accLeftContainer.height("");

      if ($(window).width() < breakpointWidth) {
        return;
      }

      const leftPanelMaxHeight = max(
        map(
          $accLeftContainer.find(".bs-advance-accordion__left-content-panel"),
          (contentPanel) => $(contentPanel).height()
        )
      );

      const cardMaxHeight = max(
        map($cardCollection, (card) => $(card).height())
      );

      $cardCollection.find(".card-body").height(cardMaxHeight);
      $accLeftContainer.height(leftPanelMaxHeight);
    });
  };

  // handle resize event
  let timeout;
  const handleResize = () => {
    if (timeout) {
      window.cancelAnimationFrame(timeout);
    }

    timeout = window.requestAnimationFrame(() => {
      applyColumnStyle();
      setPanelHeights();
    });
  };

  $(window).on("resize", handleResize);

  $(window).load(() => {
    applyColumnStyle();
    setPanelHeights();
  });
})(jQuery);
